import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const authAPI = {
    loginStep1: async (credentials) => {
        try {
            const { data } = await api.post('/api/auth/login-step1/', credentials);
            return data;
        } catch (error) {
            handleApiError(error, 'Login step 1 error:');
        }
    },
    
    loginStep2: async (username, token) => {
        try {
            const { data } = await api.post('/api/auth/login-step2/', { username, token });
            // Store the token in localStorage
            localStorage.setItem('userToken', data.access);
            localStorage.setItem('username', data.username);
            localStorage.setItem('user_first_name', data.first_name);
            localStorage.setItem('userId', data.user_id);
            return data;
        } catch (error) {
            handleApiError(error, 'Login step 2 error:');
        }
    },
    
    // Keep existing login method for backward compatibility
    login: async (credentials) => {
        try {
            const step1Response = await authAPI.loginStep1(credentials);
            
            if (step1Response && step1Response.requires_2fa) {
                // Return partial response, frontend will handle 2FA step
                return { ...step1Response, needs2FA: true };
            }
            
            // Store tokens and return
            if (step1Response && step1Response.access) {
                localStorage.setItem('userToken', step1Response.access);
                localStorage.setItem('username', step1Response.username);
                localStorage.setItem('user_first_name', step1Response.first_name);
                localStorage.setItem('userId', step1Response.user_id);
            }
            return step1Response;
        } catch (error) {
            handleApiError(error, 'Login error:');
        }
    },
}; 